"use strict";

function helper(Handlebars) {
  /**
   * Adds a "data-aid" attribute with one or more tag names
   *
   * {{aid "<tag>"}} inserts "data-aid=<tag>"
   * {{aid "<tag> <tag2>"}} inserts "data-aid=<tag>-<tag2>"
   * {{aid "<tag> <tag2> ..."}} inserts "data-aid=<tag>-<tag2>-..."
   *
   * @return {Number} sequential addition of all passed arguments
   */
  var aid = function aid() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var aiid = Array.prototype.slice.call(args, 0, -1).join('-');
    var result = "data-aid=\"".concat(Handlebars.Utils.escapeExpression(aiid), "\"");
    return new Handlebars.SafeString(result);
  };
  Handlebars.registerHelper('aid', aid);
  return aid;
}
module.exports = helper;
